import img13a from '../../../assets/gallery/13c/13c-01-HOME_Si-vivimos-sera-una-revelacion-2013-130x90cm_oleo-sobre-papel.jpg';
import img13b from '../../../assets/gallery/13c/13c-02_Si-vivimos-sera-una-revelacion-2013-130x90cm_oleo-sobre-papel.jpg';
import img13c from '../../../assets/gallery/13c/13c-03_ST-2013-130x90cm-oleo-sobre-papel.jpg';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "130 x 90 cm",
    pictureSrc: img13a,
    description: "2013",
    orientation: "v"
  },
  {
    id: 2,
    title: "",
    dimensions: "2130 x 90 cm",
    pictureSrc: img13b,
    description: "2013",
    orientation: "v"
  },
  {
    id: 3,
    title: "",
    dimensions: "130 x 90 cm",
    pictureSrc: img13c,
    description: "2013",
    orientation: "v"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];



// WEBPACK FOOTER //
// ./src/pages/gallery/13c/data13c.js